import React from 'react';

export default function Benefits() {
  const benefits = [
    {
      role: 'For Administrators',
      highlight: 'Less manual work. Better visibility.',
      desc: 'Eliminate tedious paperwork and centralize user roles, class rosters, attendance records, and grade books into one unified dashboard.',
      icon: '🏛️',
      color: 'border-blue-500/30 bg-blue-500/5',
      accent: 'text-blue-400',
    },
    {
      role: 'For Teachers',
      highlight: 'Simpler classroom management.',
      desc: 'Log attendance in seconds, build auto-graded timed quizzes, collect assignments online, and streamline parent-teacher communication.',
      icon: '🍎',
      color: 'border-emerald-500/30 bg-emerald-500/5',
      accent: 'text-emerald-400',
    },
    {
      role: 'For Students',
      highlight: 'Clearer access to learning & progress.',
      desc: 'Never miss a deadline. View timetables, solve interactive quizzes, submit homework digitally, and track academic standing in real time.',
      icon: '🎓',
      color: 'border-purple-500/30 bg-purple-500/5',
      accent: 'text-purple-400',
    },
    {
      role: 'For Parents',
      highlight: 'Better visibility into your child’s progress.',
      desc: 'Stay informed every day with real-time attendance alerts, quiz score reports, teacher notices, and 1-click PDF report card downloads.',
      icon: '👨‍👩‍👦',
      color: 'border-amber-500/30 bg-amber-500/5',
      accent: 'text-amber-400',
    },
  ];

  return (
    <section id="benefits" className="py-24 bg-slate-950/90 relative overflow-hidden border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3">
            REAL VALUE & IMPACT
          </div>
          <h2 className="font-serif text-3xl sm:text-5xl font-extrabold text-white tracking-tight mb-4">
            Designed for Every Role in Your School
          </h2>
          <p className="text-slate-400 text-base sm:text-lg">
            Purpose-built functionality that solves real operational challenges for school communities.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {benefits.map((b, idx) => (
            <div
              key={idx}
              className={`border ${b.color} rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 hover:border-white/30 backdrop-blur-md flex flex-col justify-between`}
            >
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-extrabold uppercase tracking-widest text-slate-400">
                    {b.role}
                  </span>
                  <span className="text-3xl p-2 bg-white/5 rounded-xl border border-white/10">{b.icon}</span>
                </div>

                <h3 className={`text-2xl font-extrabold ${b.accent}`}>
                  {b.highlight}
                </h3>

                <p className="text-slate-300 text-sm leading-relaxed">
                  {b.desc}
                </p>
              </div>

              <div className="mt-8 pt-4 border-t border-white/10 flex items-center justify-between text-xs font-bold text-slate-400">
                <span>Empowered Workflow</span>
                <span className="text-white">100% Integrated</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
